import isPlainObject from "lodash/isPlainObject";
import { stringifyWithLoopProtection } from "./utils";
const interceptors = [];
const loopProtection = (config) => {
    try {
        if (isPlainObject(config.data) || (Array.isArray(config.data) && isPlainObject(config.data[0]))) {
            const { result, hasCircleProp } = stringifyWithLoopProtection(config.data);
            if (hasCircleProp) {
                config.data = JSON.parse(result);
            }
        }
    }
    catch (e) {
        console.warn("loopProtection json control error");
    }
    return config;
};
interceptors.push({
    request: {
        onSuccess: loopProtection,
    },
});
export default interceptors;
